import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { appConfig } from '@base/app.config';
import { BasicObject } from '@base/common/models/services.interface';

import { IInitialConfig } from '@interfaces/config.interface';

import 'zone.js';

import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

declare global {
    interface Window {
        ConfigInitial: IInitialConfig;
        tc_vars: BasicObject;
    }
}

if (environment.production) {
    enableProdMode();
}

const xobj = new XMLHttpRequest();
xobj.overrideMimeType('application/json');
// @todo replace by fileReplacements in angular.json
// @todo uncomment this line to use Cypress
// if (window.hasOwnProperty('Cypress')) {
//     xobj.open('GET', '/config/checkout/default.mock.json', true);
// } else {
xobj.open('GET', '/config/checkout/default.json', true);
// } // Replace 'my_data' with the path to your file
xobj.onreadystatechange = (): void => {
    if (xobj.readyState === 4 && xobj.status === 200) {
        window.ConfigInitial = JSON.parse(xobj.responseText);
        bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
    }
};
xobj.send(null);
